export default "__VITE_ASSET__c84543df__"